import React from 'react'
import { LayerGroup, LayersControl, Marker, Popup, Tooltip } from 'react-leaflet'
import { VenueIconDanger } from './VenueIconDanger'
import { VenueIconWarning } from './VenueIconWarning'
import MarkerClusterGroup from 'react-leaflet-cluster'
import L from 'leaflet'
function createClusterCustomIcon(cluster) {
    return L.divIcon({
        html: `
      <div style="
        background: rgba(0, 123, 255, 0.8) !important;
        color: white;
        border-radius: 50%;
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        font-weight: bold;
        box-shadow: 0 0 10px rgba(0,0,0,0.3);
      ">
        ${cluster.getChildCount()}
      </div>
    `,
        className: 'custom-marker-cluster',
        iconSize: [40, 40]
    })
}
export default function Markers({ clients = [] }) {
    function openPopup(marker) {
        if (marker && marker.leafletElement) {
            window.setTimeout(() => {
                marker.leafletElement.openPopup()
            })
        }
    }


    return (
        <LayersControl position="topright">
            {clients.map(client => {
                const subsConGeo = client.subs.filter(
                    sub => sub.geolocalizacion && sub.geolocalizacion.includes(',')
                )
                if (!subsConGeo.length) return null

                return (
                    <LayersControl.Overlay
                        key={client.id}
                        name={`${client.nombres} ${client.apellido_paterno}`}
                        checked
                    >
                        <LayerGroup>
                            <MarkerClusterGroup chunkedLoading iconCreateFunction={createClusterCustomIcon}>
                                {subsConGeo.map(sub => {
                                    const [lat, lng] = sub.geolocalizacion
                                        .split(',')
                                        .map(parseFloat)
                                    if (isNaN(lat) || isNaN(lng)) return null

                                    const isNuevo = sub.estado === 'nuevo'

                                    return (
                                        <Marker
                                            key={sub.id}
                                            position={{ lat, lng }}
                                            icon={isNuevo ? VenueIconDanger : VenueIconWarning}
                                            ref={openPopup}
                                        >
                                            <Popup className="fw-bold" closeOnEscapeKey keepInView>
                                                <span
                                                    style={{
                                                        color: isNuevo ? 'red' : 'rgb(216, 188, 29)',
                                                    }}
                                                >
                                                    <i
                                                        className={
                                                            isNuevo
                                                                ? 'ion-person-add h6'
                                                                : 'ion-person h6'
                                                        }
                                                    />{' '}
                                                    {isNuevo ? 'Cliente nuevo' : 'cliente'}
                                                </span>
                                                <br />
                                                {' ' + sub.nombres + ' ' + (sub.apellido_paterno ? sub.apellido_paterno : '')}
                                                <br />
                                                <small>Tel: {sub.telefono}</small>
                                                <br />
                                                <small>Tipo: {sub.tipo_negocio}</small>
                                            </Popup>
                                            <Tooltip
                                                className="fw-bold border"
                                                direction="top"
                                                offset={[0, -7]}
                                                opacity={1}
                                            >
                                                <span
                                                    style={{
                                                        color: isNuevo ? 'red' : 'rgb(216, 188, 29)',
                                                    }}
                                                >
                                                    <i
                                                        className={
                                                            isNuevo
                                                                ? 'ion-person-add h6'
                                                                : 'ion-person h6'
                                                        }
                                                    />{' '}
                                                    {isNuevo ? 'nuevo cliente' : 'cliente'}
                                                </span>
                                                <br />
                                                {sub.nombres + ' ' + sub.apellido_paterno}
                                            </Tooltip>
                                        </Marker>
                                    )
                                })}
                            </MarkerClusterGroup>
                        </LayerGroup>
                    </LayersControl.Overlay>

                )
            })}
        </LayersControl>
    )
}
